query allSoccerPlayers(
  $first: Int
  $offset: Int
  $filter: SoccerPlayerWithTeamFilter
  $condition: SoccerPlayerWithTeamCondition
) {
  players: allSoccerPlayerWithTeams(
    first: $first
    offset: $offset
    filter: $filter
    condition: $condition
  ) {
    nodes {
      teams
      player {
        name
        source
        playerIndex
        playerId
        position
      }
    }
    totalCount
  }
}
